const minWidth = 150;

const InventoryProjectionsColumns = [
  {
    field: 'summaryProductGroup',
    headerName: 'Summary Product Group',
    minWidth,
  },
  {
    field: 'pipelineSystem',
    headerName: 'Pipeline System',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'available',
    headerName: 'Available (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'inTransit',
    headerName: 'In Transit (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'availableReserved',
    headerName: 'Available Reserved (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inTransitReserved',
    headerName: 'In Transit Reserved (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'totalVolume',
    headerName: 'Total Volume (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'currEffMaxAdjusted',
    headerName: 'Current Eff Maximum (Adjusted)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'overMax',
    headerName: 'Over Maximum',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'overUnderMaxVol',
    headerName: 'Over/Under Maximum Volume (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'currEffMax',
    headerName: 'Current Effective Maximum (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'contractTankMaxAdjusted',
    headerName: 'Contract Tank Maximum Adjustment (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'rackMaxAdjusted',
    headerName: 'Rack Maximum Adjustment (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'minimumLocationIdName',
    headerName: 'Location ID',
    minWidth,
  },
  {
    field: 'minimumLocationShortName',
    headerName: 'Minimum Location',
    minWidth,
  },
  {
    field: 'minimumLocationVolume',
    headerName: 'Minimum Location Volume (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'currEffMinAdjusted',
    headerName: 'Current Eff Minimum (Adjusted)',
    minWidth,
    type: 'number',
  },
  {
    field: 'underMin',
    headerName: 'Under Minimum',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'additionalVolNeeded',
    headerName: 'Additional Volume Needed (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'currEffMin',
    headerName: 'Current Effective Minimum (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'contractTankMinAdjusted',
    headerName: 'Contract Tank Minimum Adjustment (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'rackMinAdjusted',
    headerName: 'Rack Minimum Adjustment (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'contractTankMinPercent',
    headerName: 'Contract Tank Minimum %',
    minWidth,
    type: 'number',
  },
];

export default InventoryProjectionsColumns;
